import React from "react";

const DashboardComponent = () => {

    return (
        <>
            {/* <!--start page wrapper --> */}
            <div className="p-5">
                <h6 className="d-flex text-secondary">
                    Lead Summary
                </h6>
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-primary">
                            <div className="card-body">
                                <h5 className="text-primary mb-0 d-flex">New</h5>
                                <h5 className="mb-0"><i className="fadeIn animated bx bx-rupee d-flex" /></h5>
                                <h5 className="d-flex">
                                    58718440.00</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">193 Leads</p>
                                    <p className="mb-0 font-13">37.12%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-info">
                            <div className="card-body">
                                <h5 className="text-info mb-0 d-flex">Contacted</h5>
                                <h5 className="mb-0"><i className="fadeIn animated bx bx-rupee d-flex" /></h5>
                                <h5 className="d-flex">
                                    51500000.00</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">135 Leads</p>
                                    <p className="mb-0 font-13">25.96%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-warning">
                            <div className="card-body">
                                <h5 className="text-warning mb-0 d-flex">Quoted</h5>
                                <h5 className="mb-0"><i className="fadeIn animated bx bx-rupee d-flex" /></h5>
                                <h5 className="d-flex">
                                    23909800.00</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">31 Leads</p>
                                    <p className="mb-0 font-13">5.96%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-warning">
                            <div className="card-body">
                                <h5 className="text-warning mb-0 d-flex">Demo</h5>
                                <h5 className="mb-0"><i className="fadeIn animated bx bx-rupee d-flex" /></h5>
                                <h5 className="d-flex">
                                    18583599.98.00</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">57 Leads</p>
                                    <p className="mb-0 font-13">10.96%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-success">
                            <div className="card-body">
                                <h5 className="d-flex mb-0 text-success">Won</h5>
                                <h5 className="d-flex"><i className="fadeIn animated bx bx-rupee d-flex" />18583599.98</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">50 Leads</p>
                                    <p className="mb-0 font-13">9.62%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-danger">
                            <div className="card-body">
                                <h5 className="text-danger mb-0 d-flex">Lost</h5>
                                <h5 className="d-flex"><i className="fadeIn animated bx bx-rupee d-flex" />18583599.98</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">57 Leads</p>
                                    <p className="mb-0 font-13">10.96%</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>{/*end row*/}

                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4 ">
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-secondary">
                            <div className="card-body">
                                <h5 className="d-flex mb-0 text-secondary">Junk</h5>
                                <h5 className="d-flex"><i className="fadeIn animated bx bx-rupee d-flex" />7000000.00</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">33 Leads</p>
                                    <p className="mb-0 font-13">6.35%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-danger">
                            <div className="card-body">
                                <h5 className="text-danger mb-0 d-flex">No Requirement</h5>
                                <h5 className="d-flex"><i className="fadeIn animated bx bx-rupee d-flex" />100000.00</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">13 Leads</p>
                                    <p className="mb-0 font-13">2.15%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>{/*end row*/}

                <h6 className="d-flex text-secondary">
                    Activity Summary
                </h6>
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-warning">
                            <div className="card-body">
                                <h5 className="text-warning mb-0 d-flex">Not Started</h5>
                                <h5 className="d-flex">
                                    83</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">28.62%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-info">
                            <div className="card-body">
                                <h5 className="text-info mb-0 d-flex">In Progress</h5>
                                <h5 className="d-flex">
                                    147</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">50.69%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-warning">
                            <div className="card-body">
                                <h5 className="text-warning mb-0 d-flex">Completed</h5>
                                <h5 className="d-flex">
                                    27</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">9.31%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-warning">
                            <div className="card-body">
                                <h5 className="text-warning mb-0 d-flex">Cancelled</h5>
                                <h5 className="d-flex">
                                    0</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">0.00%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-danger">
                            <div className="card-body">
                                <h5 className="text-danger mb-0 d-flex">Lost</h5>
                                <h5 className="d-flex">
                                    20</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">6.90%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-danger">
                            <div className="card-body">
                                <h5 className="text-danger mb-0 d-flex">No Requirement</h5>
                                <h5 className="d-flex">
                                    13</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">4.48%</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>{/*end row*/}

                <h6 className="d-flex text-secondary">
                    Customer Summary
                </h6>
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-warning">
                            <div className="card-body">
                                <h5 className="text-warning mb-0 d-flex">Total Customers</h5>
                                <h5 className="d-flex">
                                    350</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">28.62%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-success">
                            <div className="card-body">
                                <h5 className="text-success mb-0 d-flex">Active Customers</h5>
                                <h5 className="d-flex">
                                    350</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">100% Active Customers</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-2">
                        <div className="card radius-10 border-start border-0 border-4 border-danger">
                            <div className="card-body">
                                <h5 className="text-danger mb-0 d-flex">Inactive Customers</h5>
                                <h5 className="d-flex">
                                    0</h5>
                                <div className="d-flex justify-content-between align-item-center text-primary">
                                    <p className="mb-0 font-13">0% Inactive Customers</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>{/*end row-
*/}

            </div>

            {/* <!--end page wrapper --> */}
        </>
    )
}

export default DashboardComponent;